import React, {useState} from "react";
import {Portlet, PortletBody, PortletFooter, PortletHeader, PortletHeaderToolbar} from "../../../../components/Portlet";
import { Formik } from "formik";
import {Col, Dropdown, Form, Row} from "react-bootstrap";
import LoadingButton from "../../../base/components/loadingButton";
import * as yup from "yup";
import FormRow from "../../../base/components/forms/formRow";
import { connect } from "react-redux";
import { LoadList } from "../../../../redux/actions/base";
import CitySelect from "../../../base/components/forms/citySelect";
import _ from "lodash";
import {useParams} from "react-router-dom";
import {useController, useForm} from "react-hook-form";
import BlockUi from "@availity/block-ui";
import DropdownButton from "react-bootstrap/DropdownButton";
import FormHookInput from "../../../air/airBooking/components/formHookInput";
import ApiSelect from "../../../base/components/forms/apiSelect";
import RightEditComponent from "../../city/components/rightEditComponent";

const AirportForm = ({ data, onSubmit, edit, deleteAction }) => {
  const { id } = useParams();
  const {register,
    control,
    setValue,
    watch,
    reset,
    getValues,
    formState:{errors},
    handleSubmit} = useForm(
    {defaultValues:data}
  )
  const {
    field: { onChange: cityOnChange, value: cityValue }
  } = useController({
    name: `city`,
    control,
    rules: { required: true },
    defaultValue: data.city
  });
  const onSubmitBase = (data)=>{
  if(data.lat === '' || isNaN(data.lat) ) delete data.lat
  if(data.lon === '' || isNaN(data.lon)) delete data.lon
  onSubmit(data)
  }

  const lat = watch("lat")
  const lng = watch("lon")

  return <Row>
    <Col lg={6}>
      <Portlet>
        <PortletHeader
          title={edit ? "Редактирование аэропорта" : "Создание аэропорта"}
          toolbar={
            <PortletHeaderToolbar>
              {edit &&
                <DropdownButton variant="outline-danger" title="Удалить">
                  <Dropdown.Item as="button" onClick={deleteAction}>
                    Да! Удалить
                  </Dropdown.Item>
                </DropdownButton>
              }
            </PortletHeaderToolbar>
          }
        />
          <form onSubmit={handleSubmit(onSubmitBase)} >
            <PortletBody className={'d-flex flex-column gap-3'}>
              <FormHookInput
                register={register(`name`,)}
                label={'Название'}
                errors={errors}
              />
              <FormHookInput
                register={register(`nameEn`, {
                  required: true,
                })}
                label={'Название En'}
                errors={errors}
              />
              <FormHookInput
                register={register(`iataCode`,)}
                label={'iata Код'}
                errors={errors}
              />
              <FormHookInput
                register={register(`icaoCode`,)}
                label={'icao Код'}
                errors={errors}
              />
              <FormHookInput
                register={register(`utsOffset`, {
                  valueAsNumber: true,
                })}
                label={'Время UTC+X'}
                errors={errors}
              />
              <FormHookInput
                register={register(`lat`, {
                  valueAsNumber: true,
                })}
                label={'Lat'}
                errors={errors}
              />
              <FormHookInput
                register={register(`lon`, {
                  valueAsNumber: true,
                })}
                label={'Lon'}
                errors={errors}
              />
              <ApiSelect
                value={cityValue}
                label={'Город'}
                hasError={_.get(errors, `seller`)}
                url={"/api/locations/cities/searchInput"}
                cb={cityOnChange}
              />
            </PortletBody>
            <PortletFooter className={'text-end'}>
              <LoadingButton title={"Сохранить"} />
            </PortletFooter>
          </form>
      </Portlet>
    </Col>
    <RightEditComponent edit={edit}
                        link={`/api/locations/airports/syncAirport/${id}`}
                        citySyncCb={(data)=>{
                          console.log('airport',data.airport)
                          reset({
                            ...getValues(),
                            ...data.airport
                          });
                        }}
                        defaultZoom={11}
                        coordinates={!!lat && !!lng ? {lat, lng } : null}/>
  </Row>
};
export default AirportForm;
